import React, {useRef, useState, useEffect, useCallback} from 'react';
// import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';

import SearchService from '../../services/SearchService';
import DatabaseService from '../../services/DatabaseService';

import RapportiNew from './RapportiNew';
import Layout from '../layout/Layout';
import Filters from './../layout/Filters';

import Container from '../../common/components/Container';
import Row from '../../common/components/Row';
import Col from '../../common/components/Col';
import Table from '../../common/components/Table';
import Loading from '../../common/components/Loading';
import Card from '../../common/components/Card';
import Button from '../../common/components/Button';
import Overlay from './../../common/components/Overlay';

import {getConfig} from '../../config';

const Header = styled.div.withConfig({displayName:'-Header'})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 40px;
`;
const TableWrapper = styled.div.withConfig({displayName:'-TableWrapper'})`
  & table tr td{
    white-space: nowrap;
  }
  & table tr td:nth-child(2),
  & table tr td:nth-child(3){
    word-break: break-all;
    white-space: unset;
  }
  overflow-x: auto; 
`;
const TableActions = styled.div.withConfig({displayName:'-TableActions'})`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > *{
    margin-right: 5px;
  }
`;
const NoResult = styled.div.withConfig({displayName:'-NoResult'})`
  text-align: center;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
  font-family: 'Roboto',cursive;
  font-size: 30px;
`;


const Tag = styled.span`
	display: inline-block;
	position: relative;
	top: -1px;
	background-color: #b9b9b9;
	font-size: 12px;
	border-radius: 2px;
	color: #ffffff !important;
	font-weight: 400;
	letter-spacing: 0.5px;
	padding: 4px 8px;

	&:hover{
		background-color: #ffffff;
		color: #0d609d !important;
		text-decoration: none;
	}
`;
const ClearFilters = styled.div.withConfig({displayName:'-ClearFilters'})`
  text-align: right;
  margin-top: 10px;
`;


const RapportiList = ({layout}) => {
  let scrollRef = useRef(null);
  // let navigate = useNavigate();
  const [list, setList] = useState(null);
  const [showModalNew, toggleModalNew] = useState(false);
  // const [page, setPage] = useState(0);
  const [selected, setSelected] = useState([]);
  const [macrolotti, setMacrolotti] = useState([]);
  const [subaree, setSubaree] = useState([]);
  const [sondaggi, setSondaggi] = useState([]);

  const [filters, setFilters] = useState({
    "codice_cesi": "",
    "document_t": null,
    "document_e": null,
    "siglaMacrolotto": null,
    "siglaSubarea": null,
    "siglaSondaggio": null
  });

  const changeFilters = useCallback((name, value) => {
    setList(null);
    // setPage(0);
    let tempFilters = {...filters};
    tempFilters[name] = value;
    setFilters(tempFilters);
  }, [filters]);

  const getList = useCallback(() => {
    if(scrollRef && scrollRef.current){
      scrollRef.current.scrollTo(0,0);
    }
    SearchService.searchRdp(
			"*",
			(filters.codice_cesi ? 
        "(" + 
          filters.codice_cesi.split(/,| /).map((v) => v ? "codice_cesi: "+ v : null ).filter(x => x).join(" || ")
        + ") && "
      : "" ) +
			(filters.document_t === 1 ? "has_document_t:true && " : "") +
			(filters.document_e === 1 ? "has_document_e:true && " : "") +
			(filters.siglaMacrolotto ? "siglaMacrolotto:"+filters.siglaMacrolotto+" && " : "") +
			(filters.siglaSubarea ? "siglaSubarea:"+filters.siglaSubarea+" && " : "") +
			(filters.siglaSondaggio ? "siglaSondaggio:"+filters.siglaSondaggio+" && " : "") +
			"obj_type:CAMP"
		).then((response) => {
      console.log(response);
			setList(response)
    });

  }, [filters]);

  useEffect(() => { 
		getList();
  }, [getList, filters]);

  useEffect(() => {
    
    DatabaseService.listMacrolotti(1).then((response) => {
    	setMacrolotti(response);	
    });
    DatabaseService.listSubaree().then((response) => {
    	setSubaree(response);	
    });
    DatabaseService.listSondaggi().then((response) => {
    	setSondaggi(response);	
    });
  }, [])

  const deleteFile = useCallback((id, type) => {
    setList(null);
    DatabaseService.deleteRdp(id, type).then(() => {
      setTimeout(() => {
        getList();
      }, 3000);
    });
  }, [getList]);

  return (
    <Layout layout={layout}>
      <div ref={scrollRef}>
        <Container>
          <Header>
            <Title><i className="fa-solid fa-cubes-stacked"></i> Rapporti di prova</Title>   
            <div>
              <Button onClick={selected.length === 0 ? () => {} : () => toggleModalNew("t")} variant={selected.length === 0 ? "disabled" : "default"}>+ File Terreno</Button>    
              &nbsp;&nbsp;&nbsp;
              <Button onClick={selected.length === 0 ? () => {} : () => toggleModalNew("e")} variant={selected.length === 0 ? "disabled" : "default"}>+ File Eluato</Button>
            </div>         
          </Header>

          <Row>
            <Col>
              <Card>
                <Row>
                  <Col widthmd="12">
                    <Filters
                      onChange={(...args) => changeFilters(...args)}
                      fields={
                        [
                          {
                            "label": "Codice CESI",
                            "name": "codice_cesi",
                            "size": 12,
                            "type": "text",
                            "placeholder": null,
                            "value": filters.codice_cesi
                          },{
                            "label": "Macrolotti",
                            "name": "siglaMacrolotto",
                            "size": 3,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.siglaMacrolotto,
                            "options": [{
                              "name": "Tutti",
                              "value": null,
                            }].concat(macrolotti.map((item) => ({
                              "name": item.siglaMacrolotto + (item.descrizione ? " - " + item.descrizione : ""),
                              "value": item.siglaMacrolotto
                            })))
                          },{
                            "label": "Subaree",
                            "name": "siglaSubarea",
                            "size": 3,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.siglaSubarea,
                            "options": [{
                              "name": "Tutti",
                              "value": null,
                            }].concat(subaree.map((item) => ({
                              "name": item.siglaSubarea + (item.nome ? " - " + item.nome : ""),
                              "value": item.siglaSubarea
                            })))
                          },{
                            "label": "Sondaggi",
                            "name": "siglaSondaggio",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.siglaSondaggio,
                            "options": [{
                              "name": "Tutti",
                              "value": null,
                            }].concat(sondaggi.map((item) => ({
                              "name": item.siglaSondaggio,
                              "value": item.siglaSondaggio
                            })))
                          },{
                            "label": "File Terreno",
                            "name": "document_t",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.document_t,
                            "options": [
                              {
                                "name": "Tutti",
                                "value": null
                              },{
                                "name": "Sì",
                                "value": 1
                              }
                            ]
                          },{
                            "label": "File Eluato",
                            "name": "document_e",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.document_e,
                            "options": [
                              {
                                "name": "Tutti",
                                "value": null
                              },{
                                "name": "Sì",
                                "value": 1
                              }
                            ]
                          }
                        ]
                      }
                    />
                    <ClearFilters>
                      <Button size={"small"} onClick={() => setFilters({
                        "codice_cesi": "",
                        "document_t": null,
                        "document_e": null,
                        "siglaMacrolotto": null,
                        "siglaSubarea": null,
                        "siglaSondaggio": null
                      })}>Svuota filtri</Button>
                    </ClearFilters>
                    <hr/>
                    {list ?
                      list.length > 0 ?
                        <>
                          <TableWrapper>
                            <Table
                              selectable
                              selected={selected}
                              onSelect={(ids) => {
                                // console.log(id);
                                let tempSelected = [...selected]
                                ids.forEach(id => {
                                  if(!selected.includes(id)){
                                    tempSelected.push(id);
                                  }else{
                                    tempSelected = tempSelected.filter(e => e !== id);
                                  }                    
                                });
                                setSelected(tempSelected);
                              }}
                              columns={[
                                "Codice Campione",
                                "Sigla Macrolotto - Sigla SubArea - Codice Sondaggio",
                                "Codice CESI",
                                "File Terreno",
                                "File Eluato",
                              ]}
                              values={
                                list.map(item => ({
                                  id: item.document.codice_cesi,
                                  values: [
                                    item.document.siglaCampione,
                                    item.document.siglaMacrolotto + " - " + item.document.siglaSubarea + " - " + item.document.siglaSondaggio,  
                                    item.document.codice_cesi,  
                                    item.document.document_t ? 
                                      <TableActions onClick={(e) => {e.preventDefault(); e.stopPropagation()}}>
                                        <a onClick={(e) => {e.stopPropagation()}} href={getConfig("defaultBucketUrl") + item.document.document_t} target="_blank" rel="noreferrer"><Tag>RDP T</Tag></a>
                                        <Button size={"small"} onClick={() => deleteFile(item.document.codice_cesi, "T")}>Rimuovi file</Button>
                                      </TableActions>
                                    : "-",         
                                    item.document.document_e ? 
                                      <TableActions onClick={(e) => {e.preventDefault(); e.stopPropagation()}}>
                                        <a onClick={(e) => {e.stopPropagation()}} href={getConfig("defaultBucketUrl") + item.document.document_e} target="_blank" rel="noreferrer"><Tag>RDP E</Tag></a>
                                        <Button size={"small"} onClick={() => deleteFile(item.document.codice_cesi, "E")}>Rimuovi file</Button>
                                      </TableActions>
                                    : item.document.has_eluato ? "-" : "X"
                                  ]
                                }))
                              }
                            />
                          </TableWrapper>
                        </>
                      : <NoResult>There are no results.</NoResult>
                    : <Loading />}
                  </Col>
                </Row>
                {/* {totPages > 1 ?
                  <OzPagination totPages={totPages} currentPage={page} onChange={((val) => setPage(val))} />
                : null } */}
              </Card>
            </Col>
          </Row>


          {showModalNew ? (
            <Overlay>
              <RapportiNew
                selected={selected}
                type={showModalNew}
                fnSuccess={(uuid) => {
                  // navigate("/users/"+uuid);
                  setSelected([]);
                  setList(null);
                  setTimeout(() => {
                    getList();
                  }, 10000);
                  toggleModalNew(false);
                }}
                fnCancel={() => toggleModalNew(false)}
              />
            </Overlay>
          ) : null}

          
        </Container>
      </div>
    </Layout>
  )
}

export default RapportiList;
